import I18n from 'I18n';
/**
 * @deprecated Use `sortBusinessUnitsByPrimaryBrand` instead, which accepts a
 * dynamic `primaryBrandId` rather than hardcoding BU 0 as the primary brand.
 */
export const sortBusinessUnitsByName = (buA, buB) => {
  if (buA.id === 0) return -1;
  if (buB.id === 0) return 1;
  return buA.name.toLocaleLowerCase().localeCompare(buB.name.toLocaleLowerCase());
};

/**
 * Sorts two business units so the primary brand always comes first,
 * with remaining units sorted alphabetically by name.
 *
 * Resolve `primaryBrandId` via `BusinessUnitsService#getPrimaryBrandId`.
 */
export const sortBusinessUnitsByPrimaryBrand = (buA, buB, primaryBrandId) => {
  if (buA.id === primaryBrandId && buB.id === primaryBrandId) return 0;
  if (buA.id === primaryBrandId) return -1;
  if (buB.id === primaryBrandId) return 1;
  return buA.name.toLocaleLowerCase().localeCompare(buB.name.toLocaleLowerCase());
};

/**
 * @deprecated Use `getBusinessUnitDisplayNameByPrimaryBrand` instead, which accepts a
 * dynamic `primaryBrandId` rather than hardcoding BU 0 as the primary brand.
 */
export const getBusinessUnitDisplayName = (name, id) => {
  if (id === 0) {
    return `${name} ${I18n.text('ui-business-units-lib.labels.account')}`;
  }
  return name;
};

/**
 * Returns the display name for a business unit. If the unit is the primary brand,
 * appends the account label suffix.
 *
 * Resolve `primaryBrandId` via `BusinessUnitsService#getPrimaryBrandId`.
 */
export const getBusinessUnitDisplayNameByPrimaryBrand = (name, id, primaryBrandId) => {
  if (id === primaryBrandId) {
    return `${name} ${I18n.text('ui-business-units-lib.labels.account')}`;
  }
  return name;
};